import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faFilter } from '@fortawesome/free-solid-svg-icons';
import { Category } from '../../types/Category';
import { Brands } from '../../types/Brands';
import buttonListViewSelected from '../../assets/button_list_view_selected.svg';
import buttonListView from '../../assets/button_list_view.svg';
import buttonThumbnailViewSelected from '../../assets/button_thumbnail_view_selected.svg';
import buttonThumbnailView from '../../assets/button_thumbnail_view.svg';
import './ProductTopBar.scss'; // Create this SCSS file for mobile styles

interface ProductTopBarProps {
  categoryId: string | null;
  brandId: string | null;
  sortOrder: string;
  categories: Category[]; 
  brands: Brands[]; 
  getCategoriesToDisplay: () => Category[]; 
  onCategoryChange: (categoryId: string | null) => void;
  onBrandChange: (brandId: string | null) => void;
  onSortChange: (sortOrder: string) => void;
  viewMode: 'grid' | 'list';
  onViewModeChange: (mode: 'grid' | 'list') => void;
}

const ProductTopBar: React.FC<ProductTopBarProps> = ({
  categoryId,
  brandId,
  sortOrder,
  categories,
  brands,
  getCategoriesToDisplay,
  onCategoryChange,
  onBrandChange,
  onSortChange,
  viewMode,
  onViewModeChange,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1100);
    };

    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const toggleView = () => {
    if(viewMode=='list'){
        onViewModeChange('grid');
    }else{
        onViewModeChange('list');
    }
  }
  const CategoryList = ({ categories, selectedId, onSelect, level = 0 }) => (
    <ul className="filter-list-inside">
      {categories.map((category) => (
        <li key={category.id} style={{ paddingLeft: `${level * 16}px` }}>
          <label className="checkbox-style">
            <input
              type="checkbox"
              checked={selectedId === category.id}
              onChange={() =>
                selectedId === category.id
                  ? onSelect(null) // deselect
                  : onSelect(category.id) // select new
              }
            />
            <span className="custom-checkbox" />
            {category.name}
          </label>
  
          {category.children && category.children.length > 0 && (
            <CategoryList
              categories={category.children}
              selectedId={selectedId}
              onSelect={onSelect}
              level={level + 1}
            />
          )}
        </li>
      ))}
    </ul>
  );
  const renderDesktopFilters = () => (
    <div className="filters">
      

      <div className="select-wrapper">
        <select
          value={sortOrder}
          onChange={(e) => onSortChange(e.target.value)}
        >
              <option value="lowToHigh">Τιμή Αύξουσα</option>
              <option value="highToLow">Τιμή Φθίνουσα</option>
              <option value="aToZ">Α-Ω</option>
              <option value="zToA">Ω-Α</option>
        </select>
        <FontAwesomeIcon icon={faChevronDown} className="select-arrow" />
      </div>
    </div>
  );

  const renderMobileFilters = () => (
    <>
      <button className="mobile-filter-button" onClick={toggleFilters}>
        <span>Φίλτρα</span>
        <FontAwesomeIcon icon={faFilter} />
      </button>

      {showFilters && (
        <div className="mobile-filters-dropdown">
            <div className="filter-group">
        <h4>Κατηγορία</h4>
        <ul className='filter-list mob'>
            <CategoryList
                categories={categories}
                selectedId={categoryId}
                onSelect={onCategoryChange}
                />
        </ul>
      </div>

      <div className="filter-group">
        <h4>Μάρκα</h4>
        <ul className="filter-list mob">
        {brands.map((brand) => (
            <li key={brand.id}>
            <label className="checkbox-style">
                <input
                type="checkbox"
                checked={brandId === brand.id}
                onChange={() => {
                    if (brandId === brand.id) {
                    onBrandChange(null);
                    } else {
                    onBrandChange(brand.id);
                    }
                }}
                />
                <span className="custom-checkbox" />
                {brand.name}
            </label>
            </li>
        ))}
        </ul>

      </div>

          <div className="filter-group">
            <label>Ταξινόμηση</label>
            <select
              value={sortOrder}
              onChange={(e) => {
                onSortChange(e.target.value);
                setShowFilters(false);
              }}
            >
              <option value="lowToHigh">Τιμή Αύξουσα</option>
              <option value="highToLow">Τιμή Φθίνουσα</option>
              <option value="aToZ">Α-Ω</option>
              <option value="zToA">Ω-Α</option>
            </select>
          </div>
        </div>
      )}
    </>
  );

  return (
    <div className="top-bar">
      <div className="col-start">
      {isMobile ? renderMobileFilters() : renderDesktopFilters()}
      </div>
      <div className="col-end">
      
        
        <div className="view-toggle"   onClick={toggleView}>
          <button 
            className={`iconButton ${viewMode === 'grid' ? 'active' : ''}`}
          
            aria-label="Grid view"
          >
            <img
              src={viewMode === 'grid' ? buttonThumbnailViewSelected : buttonThumbnailView}
              alt="Grid view"
            />
          </button>
          <button 
            className={`iconButton ${viewMode === 'list' ? 'active' : ''}`}
            aria-label="List view"
          >
            <img
              src={viewMode === 'list' ? buttonListViewSelected : buttonListView}
              alt="List view"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductTopBar;